import _slicedToArray from "/var/lib/jenkins/workspace/workspace/mr-learner-frontend-production-china/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import { useCacheToken } from '@ant-design/cssinjs';
import React from 'react';
import version from '../version';
import { DesignTokenContext, defaultTheme } from './context';
import defaultSeedToken from './themes/seed';
import formatToken from './util/alias'; // ================================== Hook ==================================

export default function useToken() {
  var _React$useContext = React.useContext(DesignTokenContext),
      rootDesignToken = _React$useContext.token,
      hashed = _React$useContext.hashed,
      theme = _React$useContext.theme,
      components = _React$useContext.components;

  var salt = "".concat(version, "-").concat(hashed || '');
  var mergedTheme = theme || defaultTheme;

  var _useCacheToken = useCacheToken(mergedTheme, [defaultSeedToken, rootDesignToken], {
    salt: salt,
    override: Object.assign({
      override: rootDesignToken
    }, components),
    formatToken: formatToken
  }),
      _useCacheToken2 = _slicedToArray(_useCacheToken, 2),
      token = _useCacheToken2[0],
      hashId = _useCacheToken2[1];

  return [mergedTheme, token, hashed ? hashId : ''];
}